import { LiveClassLessonService } from '@openeducation/oe-it-services';
import type { LiveClassLesson } from '@openeducation/oe-it-shared-types';
import { useQuery } from 'react-query';

import { useEnvironmentContext } from '../../environment/environment.provider';

export interface UseLiveClassLessonProps {
  contactId: string | undefined;
  isTeacher: boolean;
}
export const useLiveClassLesson = ({
  isTeacher,
  contactId,
}: UseLiveClassLessonProps) => {
  const { environment } = useEnvironmentContext();

  const {
    data: liveClassLessons,
    isLoading: isLoadingLiveClassLessons,
    isError: isErrorLiveClassLessons,
  } = useQuery<LiveClassLesson[]>(
    ['liveClassLesson', contactId],
    () =>
      LiveClassLessonService.getLiveClassLessons(
        environment,
        contactId as string,
        isTeacher
      ),
    {
      enabled: !!contactId,
    }
  );

  return {
    liveClassLessons,
    isLoadingLiveClassLessons,
    isErrorLiveClassLessons,
  };
};
